import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-layoutTwoActiving",
  "use": "icon-layoutTwoActiving-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-layoutTwoActiving\"><path d=\"M0 0h481.882v481.882H0z\" p-id=\"17837\" fill=\"#2c6bb8\" /><path d=\"M0 542.118h481.882V1024H0z\" p-id=\"17838\" fill=\"#2c6bb8\" /><path d=\"M542.118 0H1024v481.882H542.118z\" p-id=\"17839\" fill=\"#2c6bb8\" /><path d=\"M542.118 542.118H1024V1024H542.118z\" p-id=\"17840\" fill=\"#2c6bb8\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/layoutTwoActiving.svg
// module id = 8gEq
// module chunks = 58